<template>
    <v-form v-model="form_validation">
        <v-text-field
            id="sum"
            v-model="sum"
            :label="'Sum (EUR)' | t"
            :rules="[v => !!v || this.t('Sum is required')]"
            placeholder="18.32"
            prepend-icon="euro_symbol"
            type="number"
            @keypress="onlyIntegersWithComa"
        />
        <v-text-field
            id="description"
            v-model="description"
            :label="'Description' | t"
            counter="140"
            :placeholder="this.t('Invoice') + ' nr 12221'"
            :rules="descriptionRules"
            prepend-icon="description"
        />
        <v-text-field
            id="ref_nr"
            v-model="ref_nr"
            :label="'Reference number' | t"
            @keypress="onlyIntegers"
            counter="19"
            :rules="referenceNumberRules"
            type="number"
            placeholder="18002938120"
            prepend-icon="arrow_forward"
        />
        <v-btn :disabled="!form_validation" id="createPayment" class="mt-2" @click="addProductToDb"
            >{{ "Create" | t }}
        </v-btn>
    </v-form>
</template>

<script>
import { mapActions } from "vuex";
import { paymentMixin } from "@/mixins/payment-mixin";

export default {
    name: "create-regular-payment",
    mixins: [paymentMixin],
    methods: {
        ...mapActions(["addProduct"]),
        async addProductToDb() {
            let payload = {
                sum: this.sum,
                desc: this.description,
                ref_nr: this.ref_nr,
                type: "onetime"
            };
            await this.addProduct(payload);
        }
    }
};
</script>

<style scoped>
.asc-banks-list img {
    width: 140px;
    height: 54px;
    border-radius: 5px;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05), 0px 1px 3px rgba(0, 0, 0, 0.1);
}
</style>
